import { render, staticRenderFns } from "./UserActivityFilter.vue?vue&type=template&id=7f1d20f8&scoped=true&"
import script from "./UserActivityFilter.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserActivityFilter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d20f8",
  null
  
)

export default component.exports